import { useLanguage } from '../contexts/LanguageContext'

function PresenterProjectCard({project_name, project_description, language}){
    // Language prop is passed from parent component
    // You could add language-specific formatting here if needed
    return (
        <>
            <h1>{project_name}</h1>
            <p>{project_description}</p>
        </>
    )
}

export default PresenterProjectCard
